export class CashierSessionSummary
{
    branchCode:string;
    submittedCash:number;
    submittedCount:number;
    loggedInTime:string;
    loggedOutTime:string;
    username:string;
    name:string;
}